// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"e9aef40c","703":"95627978"}[chunkId] + ".chunk.js";
};